import { type PropsWithChildren } from "react"

import { join } from "@/utils/join"

interface IconContainerProps extends PropsWithChildren {
  className?: string
}

export const IconContainer = ({ className, children }: IconContainerProps) => {
  return (
    <div
      className={join(
        "flex items-center justify-center rounded-[50%] px-sm py-xs hover:justify-end [&>svg]:h-[20px] [&>svg]:fill-(--button-primary-fg_subtle)",
        className,
      )}
    >
      {children}
    </div>
  )
}
